import styled from 'styled-components';

export const ListContent = styled.div`  
    width: 100%;
    height: calc(100vh - 15em); 
    overflow-y: scroll;
`;